import { createSlice } from '@reduxjs/toolkit';
import { getFromLocalStorage, removeFromLocalStorage, setInLocalStorage } from '../../utils/storage';

const sessionData = getFromLocalStorage('funeraria-form')

const sessionSlice = createSlice({
    name: 'session',
    initialState: {
        sessionData: sessionData,
    },
    reducers: {
        changeSessionData: (state, action) => {
            state.sessionData = action.payload;
            if (action.payload) {
                setInLocalStorage('funeraria-form', JSON.stringify(action.payload));
            } else {
                removeFromLocalStorage('funeraria-form');
            }
        },
    }
})

export const { changeSessionData } = sessionSlice.actions;
export default sessionSlice.reducer;
